export enum NotifyType {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}
